import { Button } from 'theme-ui';
import Close from '~/assets/images/icons/close.svg';
type Props = {
  handleClose: () => void;
};
const CloseButton = ({ handleClose }: Props) => {
  return (
    <Button
      onClick={handleClose}
      variant="bare"
      sx={{
        position: 'absolute',
        zIndex: 11,
        top: ['1rem', '1.2rem'],
        right: ['1rem', '1.2rem'],
        justifySelf: 'end',
        alignSelf: 'start',
        minWidth: ['2.4rem', '3.8rem'],
        minHeight: ['2.4rem', '3.8rem'],
        width: ['2.4rem', '3.8rem'],
        height: ['2.4rem', '3.8rem'],
        svg: {
          width: '100%',
          stroke: 'var(--strokecolor)',
        },
      }}
    >
      <Close />
    </Button>
  );
};

export default CloseButton;
